import styled from 'styled-components';

export const RadioBackground = styled.div`
    background-color: ${({ isSelected, theme }) => (isSelected ? theme.colors.primary300 : theme.colors.neutral000)};
    border-radius: 100px;
    border: ${({ size }) => (size > 16 ? Math.floor(size / 16) : 1)}px solid ${({ isSelected, theme }) => (isSelected ? theme.colors.primary300 : theme.colors.neutral700)};
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
    position: relative;
    cursor: ${({ isSelected }) => (isSelected ? 'default' : 'pointer')};
`;

export const RadioSelected = styled.div`
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 100px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
    width: ${({ size }) => Math.floor(size / 2)}px;
    height: ${({ size }) => Math.floor(size / 2)}px;
    position: absolute;
    top: ${({ size }) => Math.floor(size / 4)}px;
    left: ${({ size }) => Math.floor(size / 4)}px;
`;
